import { render, staticRenderFns } from "./SignUpLPForm.vue?vue&type=template&id=dd552c04&scoped=true"
import script from "./SignUpLPForm.vue?vue&type=script&lang=js"
export * from "./SignUpLPForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpLPForm.vue?vue&type=style&index=0&id=dd552c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd552c04",
  null
  
)

export default component.exports